import React, {useEffect, useRef, useState, useCallback} from "react";
import Slider from "react-slick";
import ImageSlider from "./ImageSlider";
import Icon from "../Icon";
import {connect} from "react-redux";
import {trackSwipeImages, trackPinchZoomImages} from "../../utils/gestureTracker";

let __stripTouchCount = 0;
export const isStripTouchActive = () => __stripTouchCount > 0;

const IfloorplanSlider = (props) => {
    const {
        src, kenBurnsZoom, setKenBurnsZoom, setSlidePlayStatement,
        slidePlayStatement, index, setIndexMarker, setZoom, zoom,
        nowLevel, setLevelIndex, isPortrait, isLandscape, setHeightImage,
        kenburns, setFinishLoadImage, splashScreen, restartAfterSplashScreen,
        setRestartAfterSplashScreen, width, height, setMediaScreen,
        setMediaIndex, setMedia, setIsMarkerClicked, ...rest
    } = props;

    const isMobile = isPortrait || isLandscape;

    if (isMobile) {
        return <MobileStrip {...props} />;
    }

    return <DesktopSlider {...props} />;
};

const DesktopSlider = ({
    src, kenBurnsZoom, setKenBurnsZoom, setSlidePlayStatement,
    slidePlayStatement, index, setIndexMarker, setZoom, zoom,
    nowLevel, setLevelIndex, isPortrait, isLandscape, setHeightImage,
    kenburns, setFinishLoadImage, splashScreen, restartAfterSplashScreen,
    setRestartAfterSplashScreen, width, height, setMediaScreen,
    setMediaIndex, setMedia, setIsMarkerClicked, ...rest
}) => {
    const [sliderPlay, setSliderPlay] = useState(true);
    const [sliderZoom, setSliderZoom] = useState(false);
    const preZoomSpeed = useRef(0);
    const [nextSlide, setNextSlide] = useState(
        src.findIndex((el) => el.m_index === index && el.l_index == nowLevel)
    );

    const [settings, setSettings] = useState({
        dots: false,
        arrows: false,
        accessibility: false,
        fade: true,
        speed: 1500,
        vertical: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 7700,
        pauseOnHover: false,
        pauseOnFocus: false,
        swipeToSlide: false,
        beforeChange: function (currentSlide, nextSlide) {
            setNextSlide((prev) => nextSlide);
        },
    });

    useEffect(() => {
        if (!splashScreen && !restartAfterSplashScreen) {
            slider.current.slickGoTo(0, true);
            setRestartAfterSplashScreen(true);
        }
    }, [splashScreen]);

    useEffect(() => {
        if (!slidePlayStatement) {
            Pause();
            setSettings((prev) => ({ ...prev, speed: 200 }));
        }
    }, [slidePlayStatement]);

    useEffect(() => {
        if (src.length !== 0 && nextSlide >= 0) {
            if (index !== -1) setIndexMarker(src[nextSlide].m_index);
            setLevelIndex(src[nextSlide].l_index);
            sliderPlay && kenburns && setKenBurnsZoom({
                from: { transform: "scale(1)" },
                to: { transform: "scale(1.5)" },
                config: { duration: 8000 },
            });
            !sliderPlay && kenburns && setKenBurnsZoom({
                from: { transform: "scale(1)" },
                to: { transform: "scale(1)" },
                config: { duration: 8000 },
            });
        }
    }, [nextSlide]);

    useEffect(() => {
        for (let i = 0; i < src.length; i++) {
            if (nowLevel == src[i].l_index && index == src[i].m_index) {
                slider.current.slickGoTo(i, true);
            }
        }
        document.querySelector(".ifloorPlanSlider").style.opacity = index === -1 ? 1 : 1;
        const sliderPanels = document.getElementsByClassName("sliderPanel");
        for (let i = 0; i < sliderPanels.length; ++i) {
            sliderPanels[i].style.opacity = 0;
        }
    }, [index]);

    useEffect(() => {
        for (let i = 0; i < src.length; i++) {
            if (nowLevel == src[i].l_index && src[i].m_index == 0 && !sliderPlay) {
                slider.current.slickGoTo(i, true);
            }
        }
    }, [nowLevel]);

    const slider = useRef();

    const Play = () => {
        setSlidePlayStatement(true);
        slider.current.slickNext();
        slider.current.slickPlay();
        setSliderPlay(true);
        setSettings((prev) => ({ ...prev, autoplay: true, speed: sliderZoom ? 200 : 1500 }));
    };

    const Pause = () => {
        setSlidePlayStatement(false);
        slider.current.slickPause();
        setSliderPlay(false);
        setSettings((prev) => ({ ...prev, autoplay: false }));
        const kenburnsImg = document.getElementsByClassName("kenburns_image")[nextSlide];
        kenburnsImg && setKenBurnsZoom({
            from: { transform: kenburnsImg.style.transform },
            to: { transform: "scale(1)" },
            config: { duration: 4200 },
        });
    };

    const fade = () => {
        const sliderPanels = document.getElementsByClassName("sliderPanel");
        for (let i = 0; i < sliderPanels.length; ++i) {
            sliderPanels[i].style.opacity = 1;
        }
    };

    const Next = () => { slider.current.slickNext(); fade(); };
    const Prev = () => { slider.current.slickPrev(); fade(); };

    var zoomSlider = document.querySelector(".ifloorPlanSlider");

    useEffect(() => {
        if (zoom) document.addEventListener("keydown", listener);
        return () => document.removeEventListener("keydown", listener);
        function listener(event) {
            if (event.key === "Escape") {
                let address = document.querySelector(".addressBlock");
                if (address) address.style.display = "none";
                Zoom();
                document.activeElement.blur();
            }
        }
    }, [zoom]);

    const Zoom = () => {
        const enteringZoom = !sliderZoom;
        const prevSpeed = preZoomSpeed.current || settings.speed;
        let zoomClass = document.querySelector(".zoom__btn");
        zoomClass.style.display = "none";
        let slider = document.querySelector(".ifloorPlanSlider");
        slider.style.opacity = 0;
        document.querySelector(".plan").style.opacity = 0;
        setTimeout(() => { zoomClass.style.display = "block"; }, 300);
        setTimeout(() => {
            slider.style.opacity = 1;
            document.querySelector(".plan").style.opacity = 1;
        }, 200);
        slider.style.background = !sliderZoom ? "white" : "none";
        setZoom((zoom) => !zoom);
        zoomSlider?.classList.toggle("zoom");
        setSliderZoom((sliderZoom) => !sliderZoom);
        preZoomSpeed.current = enteringZoom ? settings.speed : 0;
        setSettings({
            ...settings,
            speed: enteringZoom ? 200 : prevSpeed,
        });
    };

    const showControl = (e) => {
        e.preventDefault();
        const sliderPanels = document.getElementsByClassName("sliderPanel");
        for (let i = 0; i < sliderPanels.length; ++i) sliderPanels[i].style.opacity = 1;
    };

    const hideControl = (e) => {
        e.preventDefault();
        const sliderPanels = document.getElementsByClassName("sliderPanel");
        for (let i = 0; i < sliderPanels.length; ++i) sliderPanels[i].style.opacity = 0;
    };
    const handleMouseLeaveSliderPanel = () => {
        const sliderPanels = document.getElementsByClassName("sliderPanel");
        for (let i = 0; i < sliderPanels.length; ++i) sliderPanels[i].style.opacity = 0;
    };

    const element = (
        <>
            <Icon name="chevronLeft" onClick={Prev} onMouseLeave={handleMouseLeaveSliderPanel}
                  style={{left: "25%", top: "50%", transform: "translateY(-50%)", position: "absolute", cursor: "pointer"}} />
            <Icon name="pause" width="10%" onClick={Pause}
                  style={{top: "50%", left: "50%", transform: "translate(-50%, -50%)", position: "absolute", cursor: "pointer"}} />
            <Icon name="chevronRight" onClick={Next} onMouseLeave={handleMouseLeaveSliderPanel}
                  style={{right: "25%", top: "50%", transform: "translateY(-50%)", position: "absolute", cursor: "pointer"}} />
        </>
    );

    const zoom_btn = (
        <div className="zoom__btn">
            {sliderZoom ? (
                <Icon name="zoomOut" width="8%" onClick={() => {
                    let address = document.querySelector(".addressBlock");
                    if (address) address.style.display = "block";
                    Zoom();
                }} style={{cursor: "pointer"}} />
            ) : (
                <Icon name="zoomIn" width="8%" onClick={() => {
                    let address = document.querySelector(".addressBlock");
                    if (address) address.style.display = "none";
                    Zoom();
                }} style={{cursor: "pointer"}} />
            )}
        </div>
    );

    const preventKenBurnReset = (e) => {
        e.preventDefault();
        kenburns && setKenBurnsZoom({
            ...kenBurnsZoom,
            from: document.getElementsByClassName("kenburns_image")[nextSlide].style.transform,
            duration: (8000 * (1.5 - document.getElementsByClassName("kenburns_image")[nextSlide].style.transform.replace("scale(", "").replace(")", ""))) / 0.5,
        });
    };

    return (
        <div className="ifloorPlanSlider" style={{display: "block"}}
             onMouseMove={showControl} onMouseLeave={hideControl} onClick={showControl}>
            <Slider key={sliderZoom ? "zoom" : "default"} ref={slider} {...settings} initialSlide={nextSlide > 0 ? nextSlide : 0}>
                {src.map((el, idx) => (
                    <div key={el.data?.id}>
                        <div style={{overflow: "hidden", height: "100%", width: "100%"}}>
                            <div style={{width: "100%", height: "100%"}}>
                                <ImageSlider src={el.data?.img} setFinishLoadImage={setFinishLoadImage}
                                    index={idx} kenburns={kenburns} currentIndex={nextSlide}
                                    kenBurnsZoom={kenBurnsZoom} isPortrait={isPortrait} isLandscape={isLandscape}
                                    setMediaScreen={setMediaScreen} setMediaIndex={setMediaIndex}
                                    setMedia={setMedia} setIsMarkerClicked={setIsMarkerClicked} />
                                <div className="zoom__prev" onClick={Prev} onMouseEnter={preventKenBurnReset} onMouseLeave={preventKenBurnReset} />
                                <div className="zoom__next" onClick={Next} onMouseEnter={preventKenBurnReset} onMouseLeave={preventKenBurnReset} />
                            </div>
                        </div>
                    </div>
                ))}
            </Slider>
            <div className="sliderPanel" onMouseEnter={preventKenBurnReset} onMouseLeave={preventKenBurnReset}>
                {element}
                {zoom_btn}
            </div>
        </div>
    );
};

const MobileStrip = ({
    src, index, setIndexMarker, setLevelIndex, nowLevel, kenburns,
    kenBurnsZoom, setKenBurnsZoom, setFinishLoadImage, isPortrait,
    isLandscape, setMediaScreen, setMediaIndex, setMedia, setIsMarkerClicked,
    splashScreen, restartAfterSplashScreen, setRestartAfterSplashScreen,
}) => {
    const stripRef = useRef(null);
    const slideRefs = useRef([]);
    const [currentSlide, setCurrentSlide] = useState(0);
    const currentSlideRef = useRef(0);
    const scrollingRef = useRef(false);
    const externalSlideRef = useRef(-1);
    const resetZoomRef = useRef(null);

    const scrollToSlide = useCallback((idx, smooth) => {
        const el = slideRefs.current[idx];
        if (!el || !stripRef.current) return;
        scrollingRef.current = true;
        stripRef.current.scrollTo({
            left: el.offsetLeft,
            behavior: smooth !== false ? "smooth" : "instant",
        });
        setTimeout(() => { scrollingRef.current = false; }, 400);
    }, []);

    useEffect(() => {
        if (!splashScreen && !restartAfterSplashScreen) {
            scrollToSlide(0, false);
            setRestartAfterSplashScreen(true);
        }
    }, [splashScreen]);

    useEffect(() => {
        currentSlideRef.current = currentSlide;
    }, [currentSlide]);

    useEffect(() => {
        for (let i = 0; i < src.length; i++) {
            if (nowLevel == src[i].l_index && index == src[i].m_index) {
                if (currentSlide !== i) {
                    if (resetZoomRef.current) resetZoomRef.current();
                    externalSlideRef.current = i;
                    scrollToSlide(i, false);
                    setCurrentSlide(i);
                }
                return;
            }
        }
    }, [index, nowLevel]);

    useEffect(() => {
        if (externalSlideRef.current >= 0) {
            externalSlideRef.current = -1;
            return;
        }
        if (src.length !== 0 && currentSlide >= 0 && currentSlide < src.length) {
            setIndexMarker(src[currentSlide].m_index);
            setLevelIndex(src[currentSlide].l_index);
        }
    }, [currentSlide]);

    useEffect(() => {
        if (!isPortrait || src.length === 0) return;
        const capPortraitPhotos = () => {
            const slides = Array.from(stripRef.current?.querySelectorAll("img") || []);
            if (slides.length === 0) return;
            let maxLandscapeHeight = Infinity;
            let anyLandscape = false;
            for (const img of slides) {
                const { naturalWidth: w, naturalHeight: h } = img;
                if (!w || !h || w <= h) continue;
                anyLandscape = true;
                const renderedHeight = img.getBoundingClientRect().height;
                if (renderedHeight > 0 && renderedHeight < maxLandscapeHeight) maxLandscapeHeight = renderedHeight;
            }
            if (!anyLandscape || maxLandscapeHeight === Infinity) return;
            for (const img of slides) {
                const { naturalWidth: w, naturalHeight: h } = img;
                if (h > w) img.style.setProperty("max-height", maxLandscapeHeight + "px", "important");
            }
        };
        const t1 = setTimeout(capPortraitPhotos, 400);
        const t2 = setTimeout(capPortraitPhotos, 1200);
        return () => { clearTimeout(t1); clearTimeout(t2); };
    }, [isPortrait, src]);

    const detectCurrentSlide = useCallback(() => {
        const container = stripRef.current;
        if (!container || scrollingRef.current) return;
        const scrollLeft = container.scrollLeft;
        const containerWidth = container.clientWidth;
        const center = scrollLeft + containerWidth / 2;
        let bestIdx = 0;
        let bestDist = Infinity;
        for (let i = 0; i < slideRefs.current.length; i++) {
            const el = slideRefs.current[i];
            if (!el) continue;
            const slideCenter = el.offsetLeft + el.offsetWidth / 2;
            const dist = Math.abs(center - slideCenter);
            if (dist < bestDist) {
                bestDist = dist;
                bestIdx = i;
            }
        }
        setCurrentSlide(bestIdx);
    }, []);

    useEffect(() => {
        const container = stripRef.current;
        if (!container) return;
        let scrollTimer;
        const onScroll = () => {
            clearTimeout(scrollTimer);
            scrollTimer = setTimeout(detectCurrentSlide, 60);
        };
        container.addEventListener("scroll", onScroll, { passive: true });
        detectCurrentSlide();
        return () => {
            container.removeEventListener("scroll", onScroll);
            clearTimeout(scrollTimer);
        };
    }, [src, detectCurrentSlide]);

    useEffect(() => {
        const container = stripRef.current;
        if (!container) return;

        const minScale = 1;
        const maxScale = 6;
        const zs = { slideIdx: -1, scale: 1, tx: 0, ty: 0, base: null, pinch: null, pan: null, lastTap: 0 };

        const clamp = (v, lo, hi) => Math.min(Math.max(v, lo), hi);

        const paintSlide = (slideEl, scale, tx, ty) => {
            slideEl.style.transform = `translate(${tx}px, ${ty}px) scale(${scale})`;
            slideEl.style.transformOrigin = "0 0";
            container.style.touchAction = scale > 1.05 ? "none" : "";
            container.style.scrollSnapType = scale > 1.05 ? "none" : "";
        };

        const resetAll = () => {
            const el = slideRefs.current[zs.slideIdx];
            if (el) {
                el.style.transform = "";
                el.style.transformOrigin = "";
            }
            const slideIdx = zs.slideIdx;
            zs.slideIdx = -1;
            zs.scale = 1;
            zs.tx = 0;
            zs.ty = 0;
            zs.base = null;
            zs.pinch = null;
            zs.pan = null;
            zs.mouseSwipe = null;
            container.style.touchAction = "";
            container.style.scrollSnapType = "";
            if (slideIdx >= 0 && slideRefs.current[slideIdx]) {
                container.scrollLeft = slideRefs.current[slideIdx].offsetLeft;
            }
        };

        resetZoomRef.current = resetAll;

        const onStart = (e) => {
            __stripTouchCount = e.touches.length;
            const sc = zs.scale;

            if (e.touches.length === 1 && sc > 1.05) {
                e.preventDefault();
                e.stopPropagation();
                zs.swipe = null;
                const now = Date.now();
                if (now - zs.lastTap < 300) { resetAll(); zs.lastTap = 0; return; }
                zs.lastTap = now;
                const t = e.touches[0];
                zs.pan = { sx: t.clientX, sy: t.clientY, ox: zs.tx, oy: zs.ty };
                return;
            }

            if (e.touches.length === 1 && sc <= 1.05) {
                e.preventDefault();
                e.stopPropagation();
                const t = e.touches[0];
                zs.swipe = { sx: t.clientX, sy: t.clientY, scrollAtStart: container.scrollLeft, moved: false };
                return;
            }

            if (e.touches.length === 2) {
                const r = container.getBoundingClientRect();
                const a = e.touches[0], b = e.touches[1];
                const aOn = a.clientX >= r.left && a.clientX <= r.right && a.clientY >= r.top && a.clientY <= r.bottom;
                const bOn = b.clientX >= r.left && b.clientX <= r.right && b.clientY >= r.top && b.clientY <= r.bottom;
                if (!aOn || !bOn) return;
                e.preventDefault();
                e.stopPropagation();
                zs.swipe = null;
                container.style.scrollSnapType = "none";
                const slideIdx = currentSlideRef.current;
                const slideEl = slideRefs.current[slideIdx];
                if (!slideEl) return;

                const prevScale = (zs.slideIdx === slideIdx) ? sc : 1;
                const prevTx = (zs.slideIdx === slideIdx) ? zs.tx : 0;
                const prevTy = (zs.slideIdx === slideIdx) ? zs.ty : 0;

                if (zs.slideIdx >= 0 && zs.slideIdx !== slideIdx) {
                    const oldEl = slideRefs.current[zs.slideIdx];
                    if (oldEl) { oldEl.style.transform = ""; oldEl.style.transformOrigin = ""; }
                }

                zs.slideIdx = slideIdx;
                zs.base = { left: r.left, top: r.top, w: r.width, h: r.height };
                zs.pan = null;
                zs.lastTap = 0;

                const mx = (e.touches[0].clientX + e.touches[1].clientX) / 2;
                const my = (e.touches[0].clientY + e.touches[1].clientY) / 2;
                const slideOffset = slideEl.offsetLeft;
                const scrollAtStart = container.scrollLeft;
                const imgIX = (mx - r.left - slideOffset + scrollAtStart - prevTx) / prevScale;
                const imgIY = (my - r.top  - prevTy) / prevScale;
                const dist = Math.hypot(e.touches[0].clientX - e.touches[1].clientX, e.touches[0].clientY - e.touches[1].clientY);
                zs.pinch = { dist, scaleAt: prevScale, imgIX, imgIY, slideOffset };
            }
        };

        const onMove = (e) => {
            if (zs.swipe && e.touches.length === 1 && zs.scale <= 1.05) {
                e.preventDefault();
                const t = e.touches[0];
                const dx = t.clientX - zs.swipe.sx;
                const dy = t.clientY - zs.swipe.sy;
                if (!zs.swipe.moved && Math.abs(dx) > 5) zs.swipe.moved = true;
                if (zs.swipe.moved) {
                    container.scrollLeft = zs.swipe.scrollAtStart - dx;
                }
                return;
            }

            if (zs.slideIdx < 0) return;
            const slideEl = slideRefs.current[zs.slideIdx];
            if (!slideEl) return;

            if (zs.pan && e.touches.length === 1 && zs.scale > 1.05) {
                e.preventDefault();
                const t = e.touches[0];
                const dx = t.clientX - zs.pan.sx;
                const dy = t.clientY - zs.pan.sy;
                const scrollOffset = container.scrollLeft - slideRefs.current[zs.slideIdx]?.offsetLeft;
                const minTx = zs.base.w * (1 - zs.scale) + scrollOffset;
                const maxTx = scrollOffset;
                const newTx = clamp(zs.pan.ox + dx, minTx, maxTx);
                const newTy = clamp(zs.pan.oy + dy, zs.base.h - zs.base.h * zs.scale, 0);
                zs.tx = newTx;
                zs.ty = newTy;
                paintSlide(slideEl, zs.scale, newTx, newTy);
                return;
            }

            const pin = zs.pinch;
            const b   = zs.base;
            if (pin && e.touches.length === 2 && b) {
                e.preventDefault();
                const d = Math.hypot(e.touches[0].clientX - e.touches[1].clientX, e.touches[0].clientY - e.touches[1].clientY);
                const mx = (e.touches[0].clientX + e.touches[1].clientX) / 2;
                const my = (e.touches[0].clientY + e.touches[1].clientY) / 2;
                const scrollCompensation = container.scrollLeft;
                const scrollOffset = scrollCompensation - pin.slideOffset;
                const raw = Math.pow(d / pin.dist, 0.5) * pin.scaleAt;
                const newScale = clamp(raw, minScale, maxScale);
                const newTx = mx - b.left - pin.slideOffset + scrollCompensation - pin.imgIX * newScale;
                const newTy = my - b.top  - pin.imgIY * newScale;
                const minTx = b.w * (1 - newScale) + scrollOffset;
                const maxTx = scrollOffset;
                const clampTx = clamp(newTx, minTx, maxTx);
                const clampTy = clamp(newTy, b.h - b.h * newScale, 0);
                zs.scale = newScale;
                zs.tx    = clampTx;
                zs.ty    = clampTy;
                paintSlide(slideEl, newScale, clampTx, clampTy);
            }
        };

        const onEnd = (e) => {
            if (zs.swipe && zs.swipe.moved) trackSwipeImages();
            if (zs.pinch) trackPinchZoomImages();
            __stripTouchCount = e.touches.length;
            zs.pinch = null;
            zs.pan   = null;
            zs.swipe = null;
            if (zs.scale <= 1.05) {
                const el = slideRefs.current[zs.slideIdx];
                if (el) { el.style.transform = ""; el.style.transformOrigin = ""; }
                zs.slideIdx = -1;
                zs.scale = 1;
                zs.tx = 0;
                zs.ty = 0;
                zs.base = null;
                container.style.touchAction = "";
                container.style.scrollSnapType = "";
            }
        };

        container.addEventListener("touchstart",  onStart, { passive: false });
        container.addEventListener("touchmove",   onMove,  { passive: false });
        container.addEventListener("touchend",    onEnd,   { passive: true });
        container.addEventListener("touchcancel", onEnd,   { passive: true });

        const onMouseDown = (e) => {
            if (e.pointerType !== "mouse") return;
            e.preventDefault();
            e.target.setPointerCapture(e.pointerId);
            const now = Date.now();
            if (zs.scale > 1.05 && now - zs.lastTap < 300) {
                zs.lastTap = 0;
                resetAll();
                return;
            }
            zs.lastTap = now;
            const r = container.getBoundingClientRect();
            zs.base = { left: r.left, top: r.top, w: r.width, h: r.height };
            if (zs.scale > 1.05) {
                zs.pan = { sx: e.clientX, sy: e.clientY, ox: zs.tx, oy: zs.ty };
            } else {
                zs.mouseSwipe = { sx: e.clientX, scrollAtStart: container.scrollLeft, moved: false };
            }
            container.style.cursor = "grabbing";
        };

        const onMouseMove = (e) => {
            if (e.pointerType !== "mouse") return;
            if (zs.scale > 1.05 && zs.pan) {
                const slideEl = slideRefs.current[zs.slideIdx];
                if (!slideEl) return;
                const dx = e.clientX - zs.pan.sx;
                const dy = e.clientY - zs.pan.sy;
                const scrollOffset = container.scrollLeft - slideRefs.current[zs.slideIdx]?.offsetLeft;
                const minTx = zs.base.w * (1 - zs.scale) + scrollOffset;
                const maxTx = scrollOffset;
                const newTx = clamp(zs.pan.ox + dx, minTx, maxTx);
                const newTy = clamp(zs.pan.oy + dy, zs.base.h - zs.base.h * zs.scale, 0);
                zs.tx = newTx;
                zs.ty = newTy;
                paintSlide(slideEl, zs.scale, newTx, newTy);
            } else if (zs.mouseSwipe) {
                const dx = e.clientX - zs.mouseSwipe.sx;
                if (!zs.mouseSwipe.moved && Math.abs(dx) > 5) zs.mouseSwipe.moved = true;
                if (zs.mouseSwipe.moved) {
                    container.scrollLeft = zs.mouseSwipe.scrollAtStart - dx;
                }
            }
        };

        const onMouseUp = (e) => {
            if (e.pointerType !== "mouse") return;
            zs.pan = null;
            zs.mouseSwipe = null;
            container.style.cursor = "";
        };

        const onWheel = (e) => {
            e.preventDefault();
            const slideIdx = zs.slideIdx >= 0 ? zs.slideIdx : currentSlideRef.current;
            const slideEl = slideRefs.current[slideIdx];
            if (!slideEl) return;

            if (zs.scale <= 1.05 && e.deltaY > 0) return;

            const r = container.getBoundingClientRect();
            const mx = e.clientX - r.left;
            const my = e.clientY - r.top;
            const slideOffset = slideEl.offsetLeft;
            const scrollAtStart = container.scrollLeft;

            if (zs.scale <= 1.05) {
                zs.slideIdx = slideIdx;
                zs.base = { left: r.left, top: r.top, w: r.width, h: r.height };
                zs.tx = 0;
                zs.ty = 0;
                container.style.scrollSnapType = "none";
                container.style.touchAction = "none";
            }

            const prevScale = zs.scale;
            const imgIX = (mx - slideOffset + scrollAtStart - zs.tx) / prevScale;
            const imgIY = (my - zs.ty) / prevScale;
            const factor = e.deltaY < 0 ? 1.1 : 1 / 1.1;
            const newScale = clamp(prevScale * factor, minScale, maxScale);
            const scrollOffset = scrollAtStart - slideOffset;
            const newTx = mx - slideOffset + scrollAtStart - imgIX * newScale;
            const newTy = my - imgIY * newScale;
            const minTx = r.width * (1 - newScale) + scrollOffset;
            const maxTx = scrollOffset;
            const clampTx = clamp(newTx, minTx, maxTx);
            const clampTy = clamp(newTy, r.height - r.height * newScale, 0);

            if (newScale <= 1.05) {
                resetAll();
                return;
            }

            zs.scale = newScale;
            zs.tx = clampTx;
            zs.ty = clampTy;
            paintSlide(slideEl, newScale, clampTx, clampTy);
        };

        container.addEventListener("pointerdown",  onMouseDown);
        container.addEventListener("pointermove",  onMouseMove);
        container.addEventListener("pointerup",    onMouseUp);
        container.addEventListener("pointercancel", onMouseUp);
        container.addEventListener("wheel",        onWheel, { passive: false });

        return () => {
            container.removeEventListener("touchstart",  onStart, false);
            container.removeEventListener("touchmove",   onMove,  false);
            container.removeEventListener("touchend",    onEnd,   false);
            container.removeEventListener("touchcancel", onEnd,   false);
            container.removeEventListener("pointerdown",  onMouseDown);
            container.removeEventListener("pointermove",  onMouseMove);
            container.removeEventListener("pointerup",    onMouseUp);
            container.removeEventListener("pointercancel", onMouseUp);
            container.removeEventListener("wheel",        onWheel);
        };
    }, []);

    return (
        <div ref={stripRef} className="ifloorPlanSlider ifloorPlanSlider--mobile"
             style={{display: "block"}}>
            <div className="ifloorPlanSlider--track">
                {src.map((el, idx) => (
                    <div key={el.data?.id}
                         ref={(node) => { slideRefs.current[idx] = node; }}
                         className="ifloorPlanSlider--slide">
                        <ImageSlider
                            src={el.data?.img}
                            setFinishLoadImage={setFinishLoadImage}
                            index={idx}
                            kenburns={kenburns}
                            currentIndex={currentSlide}
                            kenBurnsZoom={kenBurnsZoom}
                            isPortrait={isPortrait}
                            isLandscape={isLandscape}
                            setMediaScreen={setMediaScreen}
                            setMediaIndex={setMediaIndex}
                            setMedia={setMedia}
                            setIsMarkerClicked={setIsMarkerClicked}
                        />
                    </div>
                ))}
            </div>
        </div>
    );
};

const putState = (state) => {
    return { image_layout: state.image_layout };
};
const putDispatch = (dispatch) => { return {}; };

export default connect(putState, putDispatch)(IfloorplanSlider);
